<script>
import Datepicker from "vuejs-datepicker";
import { validate } from "vee-validate";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

export default {
  components: {
    Datepicker,
    Multiselect,
    vueDropzone: vue2Dropzone,
  },

  props: ["equipment_conditions", "categories", "conditions", "regions", 'images_text'],
  data() {
    return {
      category: "",
      has_media: null,
      formSent: false,
      gettingLocation: false,
      current_location: null,
      dropzoneOptions: {
        url: "/newreport/upload-media",
        timeout: 200000,
        autoProcessQueue: false,
        uploadMultiple: false,
        parallelUploads: 100,
        maxFilesize: 15,
        maxFiles: 100,
        addRemoveLinks: true,
        dictDefaultMessage: this.images_text,
        acceptedFiles: "image/jpeg,image/png,.mp4,.mkv,.avi,.mp3,.wav",
      },
      formData: {
        name: "",
        condition_id: "",
        child_condition_id: "",
        equipment_condition_id: "",
        protection: "",
        creator: "",
        creator_email: '',
        report_date: new Date(),
        region_id: "",
        operation_period: "",
        country: "",
        source: "",
        oral_testimony: "",
        categories_id: [],
        city: "",
        image_decriptions: [],
        location: {
          name: "",
          lat: "",
          lng: "",
        },
        description: "",
        oral_testimony: "",
      },
      activeCondition: [],
    };
  },
  mounted() {
    this.initMap();
    this.setMarker();
  },
  methods: {

    initMap() {
      this.map = new google.maps.Map(document.getElementById("report_map"), {
        center: { lat: 38.41, lng: 23.05 },
        zoomControl: true,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        mapTypeId: "satellite",
        mapTypeControl: true,
        zoom: 7,
      });
      google.maps.event.addListener(this.map, "click", (event) => {
        this.placeMarker(event.latLng);
      });
    },
    placeMarker(position) {
      if (!this.marker) {
        this.marker = new google.maps.Marker({
          position: position,
          map: this.map,
          draggable: true,
          animation: google.maps.Animation.DROP,
        });
        google.maps.event.addListener(this.marker, "dragend", (marker) => {
          var m_pos = marker.latLng;
          this.formData.location.lat = m_pos.lat();
          this.formData.location.lng = m_pos.lng();
          this.getLocationName(m_pos.lat(), m_pos.lng());
        });
      } else {
        this.marker.setPosition(position);
      }
      this.formData.location.lat = position.lat();
      this.formData.location.lng = position.lng();
      this.getLocationName(position.lat(), position.lng());
    },
    async setMarker() {
      let validLat = true;
      let validLng = true;

      await validate(this.formData.location.lat, "required|double").then(
        (result) => {
          if (!result.valid) {
            validLat = false;
          }
        }
      );

      await validate(this.formData.location.lng, "required|double").then(
        (result) => {
          if (!result.valid) {
            validLng = false;
          }
        }
      );

      if (!validLng || !validLat) {
        return;
      }

      var new_pos = new google.maps.LatLng(
        this.formData.location.lat,
        this.formData.location.lng
      );
      this.getLocationName(new_pos.lat(), new_pos.lng());
      this.placeMarker(new_pos);
    },
    async getLocation() {
      return new Promise((resolve, reject) => {
        if (!("geolocation" in navigator)) {
          reject(new Error("Geolocation is not available."));
        }
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            resolve(pos);
          },
          (err) => {
            reject(err);
          },
          ({
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          })
        );
      });
    },
    async getCurrentLocation() {
      this.gettingLocation = true;
      try {
        this.gettingLocation = false;
        this.current_location = await this.getLocation();
        this.formData.location.lat = parseFloat(
          this.current_location.coords.latitude
        );
        this.formData.location.lng = parseFloat(
          this.current_location.coords.longitude
        );
        alert('Τρέχουσα ακρίβεια GPS: ' + this.current_location.coords.accuracy + ' μέτρα');
        var new_pos = new google.maps.LatLng(
          this.current_location.coords.latitude,
          this.current_location.coords.longitude
        );
        this.placeMarker(new_pos);
        this.getLocationName(new_pos.lat(), new_pos.lng());
      } catch (e) {
        this.gettingLocation = false;
        this.errorLocationStr = e.message;
        console.log(this.errorLocationStr);
      }
    },
    getLocationName(latitude, longitude) {
      var geocoder;
      geocoder = new google.maps.Geocoder();
      var latlng = new google.maps.LatLng(latitude, longitude);
      geocoder.geocode({ latLng: latlng }, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            var add = results[0].formatted_address;
            var value = add.split(",");
            var count = value.length;
            var country = value[count - 1];
            var state = value[count - 2];
            var city = value[count - 3];
            this.formData.location.name = city + "," + country + "," + state;
            // x.innerHTML = "city name is: " + city;
          } else {
            console.log("none found");
            // x.innerHTML = "address not found";
          }
        } else {
          console.log(status);
          // x.innerHTML = "Geocoder failed due to: " + status;
        }
      });
    },

    sendingMultimedia(file, xhr, formData) {
      formData.append("report_id", this.newreport_id);
      const uuid = file.upload.uuid;
      let obj = this.formData.image_decriptions.find((image, i) => {
          if (image.uuid === uuid) {
            formData.append("description", image.description);
            return true; // stop searching
          }
      });
    },

    sendingMultimediaCompleted() {
      this.formSent = true;
    },


    mediaAdded() {
      this.has_media = true;
    },

    addRemovePhotosDesc() {
      const files = this.$refs.multimediaDropzone.getQueuedFiles();
      files.forEach(element => {
        const uuid = element.upload.uuid;
        const result = this.formData.image_decriptions.filter(image => {
          return image.uuid === uuid;
        });
        if(result.length == 0) {
            this.formData.image_decriptions.push({
              uuid: uuid,
              name: element.name,
              description: ''
            })
        }
      });
    },

    mediaRemoved(file) {
      const uuid = file.upload.uuid;
      let obj = this.formData.image_decriptions.find((image, i) => {
          if (image.uuid === uuid) {
              this.formData.image_decriptions.splice(i, 1)
              return true; // stop searching
          }
      });
    },

    sendForm() {
      if (this.loading) {
        console.log("loading..");
        return;
      }
      this.$refs["new_report"].validate().then((success) => {
        if (success) {
          this.loading = true;
          axios
            .post("/newreport/", this.formData, {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              this.loading = false;
              this.newreport_id = response.data.report.id;
              if (this.has_media) {
                this.uploadMedia();
              } else {
                this.formSent = true;
              }
            })
            .catch((e) => {
              this.loading = false;
              console.log(e.response.data);
              if (e.response.data.errors) {
                this.form_errors = e.response.data.errors;
              }
            });
        }
      });
    },
    uploadMedia() {
      this.loading = true;
      this.$refs.multimediaDropzone.processQueue();
    },

    toggleSelected(value) {
      alert(`${value.name}`);
    },

    getActiveCondition() {
      this.activeCondition = [];
      const result = this.conditions.filter((obj) => {
        return obj.id === this.formData.condition_id ? obj.children : null;
      });
      this.activeCondition = result;
    },
  },
  watch: {
    category: {
      deep: true,
      handler() {
        this.formData.categories_id = this.category.map((obj) => obj.id);
      },
    },
  },
};
</script>